import VacancyCandidatesBoxFilters from './VacancyCandidatesBoxFilters.component';

export default VacancyCandidatesBoxFilters;
